import { useState } from 'react'

interface Props {
  name: string
  logoUrl?: string | null
  className?: string
}

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  return (
    words
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase() || '?'
  )
}

/** The gym's uploaded logo, or its initials on the gym colour when it has none. */
export function GymLogo({ name, logoUrl, className = 'h-10 w-10 text-sm' }: Props) {
  const [broken, setBroken] = useState(false)
  if (logoUrl && !broken) {
    return (
      <img
        src={logoUrl}
        alt={name}
        onError={() => setBroken(true)}
        className={`flex-none rounded-xl bg-content1 object-cover ${className}`}
      />
    )
  }
  return (
    <span
      aria-hidden="true"
      className={`flex flex-none items-center justify-center rounded-xl bg-primary font-bold text-primary-foreground ${className}`}
    >
      {initials(name)}
    </span>
  )
}
